import React from 'react';
import { Box, Typography, Grid, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { Public as PublicIcon } from '@mui/icons-material';
import { useFavorites } from '../hooks/useFavorites';
import { usePageTitle } from '../hooks/usePageTitle';
import { MarketCard } from '../components/cards/MarketCard';
import { LoadingSpinner } from '../components/common/LoadingSpinner';
import { ErrorMessage } from '../components/common/ErrorMessage';

export const Home: React.FC = () => {
  usePageTitle('Home');
  const navigate = useNavigate();
  const { favorites, isLoading, error } = useFavorites();

  if (isLoading) {
    return <LoadingSpinner message="Loading your favorites..." />;
  }

  if (error) {
    return <ErrorMessage message="Failed to load favorites" />;
  }

  return (
    <Box pb={10}>
      <Box px={2} pt={2}>
        <Typography variant="h5" gutterBottom fontWeight="bold">
          Welcome
        </Typography>
        <Typography variant="body2" color="text.secondary" mb={3}>
          Quick access to your favorite markets and insights
        </Typography>
      </Box>

      {favorites.length > 0 ? (
        <Box px={2}>
          <Typography variant="h6" gutterBottom>
            Your Favorites
          </Typography>
          <Grid container spacing={2}>
            {favorites.map((favorite) =>
              favorite.market ? (
                <Grid item xs={12} key={favorite.id}>
                  <MarketCard market={favorite.market} showCountry={true} />
                </Grid>
              ) : null
            )}
          </Grid>
        </Box>
      ) : (
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
          minHeight="50vh"
          px={3}
        >
          <PublicIcon sx={{ fontSize: 80, color: 'text.secondary', mb: 2 }} />
          <Typography variant="h6" gutterBottom textAlign="center">
            No Favorites Yet
          </Typography>
          <Typography variant="body2" color="text.secondary" textAlign="center" mb={3}>
            Browse markets and add your favorites for quick access
          </Typography>
          <Button variant="contained" onClick={() => navigate('/continents')}>
            Browse Markets
          </Button>
        </Box>
      )}
    </Box>
  );
};
